import { createSlice } from '@reduxjs/toolkit';
import { extractHandlersFromSlice } from '@madbox/react_redux_request_handling';

const memberSlice = createSlice({
  name: 'member',
  initialState: {},
  reducers: {
    // FORGOT PASSWORD
    forgotPasswordRequest(state) {
      state.loading = true;
    },
    forgotPasswordSuccess(state) {
      state.loading = false;
      state.forgot_password_success = true;
    },
    forgotPasswordError(state) {
      state.loading = false;
    },
    forgotPasswordInit(state) {
      state.forgot_password_success = false;
    },

    // UPDATE PROFILE
    updateProfileRequest(state) {
      state.loading = true;
    },
    updateProfileSuccess(state) {
      state.loading = false;
    },
    updateProfileError(state) {
      state.loading = false;
    },

    // UPDATE PASSWORD
    updatePasswordRequest(state) {
      state.loading = true;
      state.errors = null;
    },
    updatePasswordSuccess(state) {
      state.loading = false;
      state.update_password_success = true;
    },
    updatePasswordError(state, action) {
      state.loading = false;
      state.errors = action.payload;
    },
    updatePasswordInit(state) {
      state.update_password_success = false;
    },

    // GET_ALL_ORGANIZATIONS
    getAllOrganizationsRequest(state) {
      state.loading = true;
    },
    getAllOrganizationsSuccess(state, action) {
      state.loading = false;
      state.organizations = action.payload;
    },
    getAllOrganizationsError(state) {
      state.loading = false;
    },

    // GET_ALL_APPLICATIONS
    getAllApplicationsRequest(state) {
      state.loading = true;
    },
    getAllApplicationsSuccess(state, action) {
      state.loading = false;
      state.applications = action.payload;
    },
    getAllApplicationsError(state) {
      state.loading = false;
    },

    // DISABLE_ACCOUNT
    disableAccountRequest(state, action) {
      state.loading = true;
      state.member_to_disable = {
        id: action.payload.memberId,
        is_disabled: action.payload.isDisabled,
      };
      state.disable_account_success = false;
    },
    disableAccountSuccess(state, action) {
      state.loading = false;
      state.disable_account_success = true;
      if (action.payload.isDisabled) state[action.payload.memberId] = 'remove';
    },
    disableAccountError(state) {
      state.loading = false;
      state.member_to_disable = {
        id: '',
        is_disabled: false,
      };
    },
    disableAccountInit(state) {
      state.disable_account_success = false;
      state.member_to_disable = {
        id: '',
        is_disabled: false,
      };
    },
  },
});

export const {
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordError,
  forgotPasswordInit,
  updateProfileRequest,
  updateProfileSuccess,
  updateProfileError,
  updatePasswordRequest,
  updatePasswordSuccess,
  updatePasswordError,
  updatePasswordInit,
  getAllOrganizationsRequest,
  getAllOrganizationsSuccess,
  getAllOrganizationsError,
  getAllApplicationsRequest,
  getAllApplicationsSuccess,
  getAllApplicationsError,
  disableAccountRequest,
  disableAccountSuccess,
  disableAccountError,
  disableAccountInit,
} = memberSlice.actions;

export const {
  forgotPassword,
  updateProfile,
  updatePassword,
  getAllOrganizations,
  getAllApplications,
  disableAccount,
} = extractHandlersFromSlice(memberSlice, [
  'forgotPassword',
  'updateProfile',
  'updatePassword',
  'getAllOrganizations',
  'getAllApplications',
  'disableAccount',
]);

export const reducer = memberSlice.reducer;
